import React from 'react';
import { Select, SelectItem } from 'ui/Input';
import { IAccount } from 'store/accounts.model';
import FileField from 'ui/Input/UploadArea/FileField';

const renderSourceAccountField = (accounts: IAccount[], submitting: boolean) => (
  <Select name="sourceAccount" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

export const renderTransferFieldsFrom = (accounts: IAccount[], submitting: boolean) => (
  <>{renderSourceAccountField(accounts, submitting)}</>
);

export const renderBulkFileUpload = (submitting: boolean) => (
  <>
    <FileField name="file" disabled={submitting} />
  </>
);
